import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useIdentityVerification } from "../../MyProfile/IndentityVerificationWrapper";

const IdentityVerification: React.FC = () => {
  // Type the context using the defined interface
  const { activeStep, setActiveStep } = useIdentityVerification();

  useEffect(() => {
      setActiveStep(0);
  }, [activeStep, setActiveStep]);

  return <Outlet />;
};

export default IdentityVerification;
